import React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

const VerticalSwitch = ({ onChange }) => {
    return (
        <FormGroup row>
            <FormControlLabel
                control={<Switch sx={{ transform: 'rotate(-90deg)' }} onChange={onChange} />}
                label=""
            />
        </FormGroup>
    );
};

export default VerticalSwitch;
